import { render, staticRenderFns } from "./VoteInfo.vue?vue&type=template&id=41557ff8&"
import script from "./VoteInfo.vue?vue&type=script&lang=js&"
export * from "./VoteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports